import React from 'react';
import { MessageCircle, Twitter, Instagram, Music, Linkedin, Briefcase } from 'lucide-react';
import { GeldhausLogo } from './GeldhausLogo';
export const Footer = () => {
  const whatsappNumber = '254100254254';
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=Hello%20Geldhaus,%20I%20would%20like%20to%20inquire%20about%20your%20loan%20products.`;
  return <footer className="bg-gray-800 text-white pt-16 pb-8" data-id="element-672">
      <div className="container" data-id="element-673">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12" data-id="element-674">
          <div data-id="element-675">
            <div className="mb-4" data-id="element-676">
              <a href="/" data-id="element-677">
                <GeldhausLogo size="md" variant="full" className="[&_span]:text-white [&_.text-primary-600]:text-primary-400" data-id="element-678" />
              </a>
            </div>
            <p className="text-gray-400 mb-6" data-id="element-679">
              Empowering Kenyan businesses with accessible financing solutions
              for growth and success.
            </p>
            <div className="flex space-x-4" data-id="element-680">
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" aria-label="WhatsApp" data-id="element-681">
                <MessageCircle size={20} data-id="element-682" />
              </a>
              <a href="https://twitter.com/geldhaus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" aria-label="Twitter/X" data-id="element-683">
                <Twitter size={20} data-id="element-684" />
              </a>
              <a href="https://instagram.com/geldhaus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" aria-label="Instagram" data-id="element-685">
                <Instagram size={20} data-id="element-686" />
              </a>
              <a href="https://tiktok.com/@geldhaus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" aria-label="TikTok" data-id="element-687">
                <Music size={20} data-id="element-688" />
              </a>
              <a href="https://linkedin.com/company/geldhaus" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" aria-label="LinkedIn" data-id="element-689">
                <Linkedin size={20} data-id="element-690" />
              </a>
            </div>
          </div>
          <div data-id="element-691">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-692">
              Quick Links
            </h3>
            <ul className="space-y-3" data-id="element-693">
              <li data-id="element-694">
                <a href="/#home" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-695">
                  Home
                </a>
              </li>
              <li data-id="element-696">
                <a href="/about#who-we-are" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-697">
                  About Us
                </a>
              </li>
              <li data-id="element-698">
                <a href="/#core-products" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-699">
                  Loan Products
                </a>
              </li>
              <li data-id="element-700">
                <a href="/#trade-finance" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-701">
                  Trade Finance
                </a>
              </li>
              <li data-id="element-702">
                <a href="/#contact" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-703">
                  Contact
                </a>
              </li>
              <li data-id="element-704">
                <a href="/apply" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-705">
                  Apply Now
                </a>
              </li>
              <li data-id="element-706">
                <a href="/careers#open-positions" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 flex items-center gap-2" data-id="element-707">
                  <Briefcase size={16} data-id="element-708" />
                  Join Us - We're Hiring
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-709">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-710">Legal</h3>
            <ul className="space-y-3" data-id="element-711">
              <li data-id="element-712">
                <a href="/legal/terms" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-713">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-714">
                <a href="/legal/privacy" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-715">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-716">
                <a href="/legal/compliance" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-717">
                  Data Protection & Compliance
                </a>
              </li>
              <li data-id="element-718">
                <a href="/legal/loan-agreement" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-719">
                  Loan Agreement
                </a>
              </li>
              <li data-id="element-720">
                <a href="/legal/regulatory" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300" data-id="element-721">
                  Regulatory Compliance
                </a>
              </li>
            </ul>
          </div>
          <div data-id="element-722">
            <h3 className="text-lg font-semibold mb-4 text-white" data-id="element-723">
              Newsletter
            </h3>
            <p className="text-gray-400 mb-4 text-sm" data-id="element-724">
              Yes! Send me genuinely useful emails every now and then to help me
              get the most out of Geldhaus! From Business Tips to updates.
            </p>
            <form className="space-y-3" aria-label="Newsletter subscription form" data-id="element-725">
              <label htmlFor="newsletter-email" className="sr-only" data-id="element-726">
                Email address
              </label>
              <input id="newsletter-email" type="email" placeholder="Your email address" className="w-full px-4 py-3 rounded-lg bg-gray-700 border border-gray-600 text-white placeholder-gray-400 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none" aria-label="Email address for newsletter" required data-id="element-727" />
              <button type="submit" className="w-full py-3 px-4 bg-emerald-600 hover:bg-emerald-700 text-white font-medium rounded-lg transition-colors duration-300" data-id="element-728">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        {/* Hiring Section */}
        <div className="mb-12 p-6 bg-gradient-to-r from-primary-600 to-primary-700 rounded-2xl" data-id="element-729">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-730">
            <div className="flex items-center gap-4" data-id="element-731">
              <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center" data-id="element-732">
                <Briefcase size={24} data-id="element-733" />
              </div>
              <div data-id="element-734">
                <h3 className="text-xl font-bold mb-1" data-id="element-735">Join Our Team</h3>
                <p className="text-primary-100 text-sm" data-id="element-736">
                  We're hiring! Voluntary positions available
                </p>
              </div>
            </div>
            <a href="/careers#open-positions" className="bg-white text-primary-600 hover:bg-primary-50 font-bold py-3 px-6 rounded-lg transition-all duration-300" data-id="element-737">
              View Open Positions
            </a>
          </div>
          <div className="mt-4 grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-738">
            <a href="/careers#open-positions" className="bg-white/10 backdrop-blur-sm rounded-lg p-3 hover:bg-white/20 transition-all duration-300" data-id="element-739">
              <p className="font-semibold mb-1" data-id="element-740">Social Media Executive</p>
              <p className="text-sm text-primary-100" data-id="element-741">Voluntary • Remote</p>
            </a>
            <a href="/careers#open-positions" className="bg-white/10 backdrop-blur-sm rounded-lg p-3 hover:bg-white/20 transition-all duration-300" data-id="element-742">
              <p className="font-semibold mb-1" data-id="element-743">Admin Personnel</p>
              <p className="text-sm text-primary-100" data-id="element-744">Voluntary • Nairobi</p>
            </a>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-700 text-center text-gray-400" data-id="element-745">
          <p data-id="element-746">
            &copy; {new Date().getFullYear()} Geldhaus Africa. All rights
            reserved.
          </p>
          <p className="mt-2 text-sm" data-id="element-747">
            Geldhaus is a financial services provider in Kenya.
          </p>
        </div>
      </div>
    </footer>;
};